import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import userApi from "../../api/user/user.api";
import { useState } from "react";
import ProcessingBar from "../../Util/Processingbar";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAuthModalOpen } from "../../store/features/authModalSlice";
import { motion, AnimatePresence } from "framer-motion";
import { fadeUp } from "animations/variants";

const ForgotPasswordForm = ({ switchAuthState }) => {
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setIsUploading(true);
        const response = await userApi.forgotPassword(values.email);

        console.log({ response });

        // Only show toast if success is true
        if (response?.response?.data?.success === true) {
          toast.success(response?.response?.data?.message);
          resetForm();
          dispatch(setAuthModalOpen(false));
          navigate("/");
        } else if (response?.err?.success === false) {
          toast.error(response?.err?.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Reset failed");
      } finally {
        setIsUploading(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <input
        type="email"
        name="email"
        placeholder="Enter your email"
        className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellowstar"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched.email && formik.errors.email && (
        <p className="text-red-500 text-sm">{formik.errors.email}</p>
      )}

      <motion.button
        type="submit"
        whileTap={{ scale: 0.95 }}
        whileHover={{ scale: 1.02 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="w-full text-navy hover:text-white py-2 rounded-md transition duration-300 tracking-widest uppercase hover:shadow-lg"
        disabled={isUploading}
        style={{
          background: "linear-gradient(-45deg, #fed693, #d09929)",
        }}
      >
        {isUploading ? <ProcessingBar /> : "Send Reset Link"}
      </motion.button>

      {/* Divider */}
      <motion.div
        variants={fadeUp}
        className="py-3 flex items-center justify-center gap-4"
      >
        <div className="w-20 border-t border-dashed border-gray-300"></div>
        <span className="w-2 h-2 bg-neonYellow rounded-full"></span>
        <span className="w-2 h-2 bg-neonYellow rounded-full"></span>
        <span className="w-2 h-2 bg-neonYellow rounded-full"></span>
        <div className="w-20 border-t border-dashed border-gray-300"></div>
      </motion.div>

      <button
        type="button"
        onClick={() => switchAuthState("signin")}
        className="
    w-full mt-4 py-2
    tracking-widest uppercase
    border-b border-navy border-dotted
    text-navy
    transition-all duration-300
    hover:bg-gradient-to-r
    hover:from-[#d09929] hover:to-[#fed693]
    hover:text-white
    hover:border-transparent
    hover:shadow-lg
  "
      >
        Sign In
      </button>
    </form>
  );
};

export default ForgotPasswordForm;
